module.exports = __webpack_public_path__ + "img/instadebit.71b2c15f.svg";